import { ConversionLogsTable } from "components/Tables/ConversionLogsTable/ConversionLogsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { ConversionStateType, PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/lead/")({
    component: LeadLogsPage,
    staticData: {
        permissions: [PermissionEnum.ConversionLeadLogView],
        showInSideMenu: false,
        label: "pages.log.lead.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.lead.title"),
        };
    },
});

function LeadLogsPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <ConversionLogsTable type={ConversionStateType.Lead} />
        </TenantPage>
    );
}
